<div class="modal" data-iframe-size>
  <div class="icon">
    <img [src]="warningUrl">
  </div>
  <h4 class="title" translate>
    i18n.dialog.deleteGalleryImage.title
  </h4>

  <div mat-dialog-content>
    <div class="content" translate>i18n.dialog.deleteGalleryImage.message</div>
  </div>

  <dialog-buttons [buttons]="buttons"></dialog-buttons>
</div>
